// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false
import 'jquery'
import jquery from "jquery"
window.jQuery = jquery
window.$ = jquery
import { popper } from "@popperjs/core"
import "chartkick/chart.js"
import "bootstrap-datepicker"
import DataTable from "datatables.net-dt"


var totalbottles = function() {
  var bottlesum=0;
  $('tr .quantity-cell').each(function(){
    bottlesum+=parseInt($(this).text());
  })
  $('#quantity-header').text('Quantity('+bottlesum+')');
}

function hideEmptyQuantityRows() {
  document.querySelectorAll('.quantity-cell').forEach((x) => {
    if (x.innerHTML.trim().match(/^0/)) {
      x.parentElement.style.display = 'none';
    }
  });
}

// when page first loads, don't show any of the bottles w/0 sum (desktop table)
window.onload = function(){
  hideEmptyQuantityRows();
}


//document.addEventListener("turbo:load", () => {
$( document ).ready(function(){

		$.fn.datepicker.defaults.format = "yyyy-mm-dd";
		$.fn.datepicker.defaults.todayBtn = true;
		$.fn.datepicker.defaults.todayHighlight = true;
		$.fn.datepicker.defaults.autoclose = true;
		
		// Only init DataTable when the desktop table is visible (CSS hides it on mobile)
		if ($('#winetable').is(':visible') && !$.fn.dataTable.isDataTable('#winetable')){
    $('#winetable').DataTable({
      columnDefs: [
	    {
	      targets: [-1],
	      orderable: false,
	    },
      ],

      paging: false,
      searching: true,
      drawCallback: totalbottles,
    })
  }
  
		$("tr[data-link]").click(function() {
		  window.location = $(this).data("link")
		})

//  $('.js-selectize').selectize({ create:true });

  // hide/show zero bottles (desktop table rows; mobile cards use wine-filter)
  $('#flexSwitchCheckDefault').change(function(){
    const showEmpties = $('input:checked').length > 0;
    const c = document.querySelectorAll(`.quantity-cell`)
      c.forEach((x) => {
										if(x.innerHTML.trim().match(/^0/))
										{
												if( !showEmpties )
																x.parentElement.style.display = 'none'
												else
																x.parentElement.style.display = 'table-row'
										}
						})
		})

  // capture submit and merge the split tasting_notes back into one field
  $("form").submit(function(event){
    var res='[';
    var str="";
    $("[name^=wine-tasting-]").each(function(i,e){
      if (0 !== e.value.trim().length)  {
        str=e.value.trim();
      }

      if(0 !== str.trim().length) {
        if (e.name.includes("-date")){
          // replace } with }, if we dont have a note and have multiple tasting dates.
          res = res.replace(/}$/,"},")
          res+="{&quot;date&quot;=>&quot;";
          res+=str
          // end with } rather than , to support having a tasting note just a date
          res+="&quot;}"
        }else if(e.name.includes("-note")){
          // replace trailing } of date with , if we have a note
          res = res.replace(/}$/,",")
          res+="&quot;note&quot;=>&quot;";
          res+=str;
          res+="&quot;},"
        }else{
          console.log("Nothing found")
        }
      }
      str="";
    });

    // cleanup any dangling commas at the end
    if (res.slice(-1) === ','){
      res=res.slice(0,-1);
    }
    res+="]";
    console.log(res);
    str='<input type="hidden" name="tasting_notes" value="';
    str += res;
    str += '\" />';

    $(str).appendTo('form');
    return true;
  });
})
